module.exports = __webpack_public_path__ + "img/chicks.6e10027c.svg";